import {request} from "@/main";

import {AuthResponse, ContextCompany, UserProfile} from "@/entities/User/model/types";
import axios from "axios";
import {getCookie} from "@/shared/lib/utils/cookie";

export const login = async (lang: string, login: string, password: string): Promise<AuthResponse> => {
    return (await axios.post('/proxy/account-recovery-api.bpmn/auth/login', {lang, login, password})).data;
};

export const getUserProfile = async (): Promise<UserProfile> => {
    return (await request.get(`/proxy/profile-api.bpmn/api/v1/profile/user`)).data;
}

export const checkingCodeSMSAndGettingTokenOtp = async (phoneNumber: string, code: string, lang: string): Promise<AuthResponse> => {
    return (await axios.post('/proxy/account-recovery-api.bpmn/api/v1/account-recovery/verifyCode/otp/sms', {
        phoneNumber,
        code,
        lang
    })).data;
};

export const checkingCodeEmailAndGettingTokenOtp = async (email: string, code: string, lang: string): Promise<AuthResponse> => {
    return (await axios.post('/proxy/account-recovery-api.bpmn/api/v1/account-recovery/verifyCode/otp/email', {
        email,
        code,
        lang
    })).data;
};

export const checkingCodeSMSAndGettingTokenReg = async (phoneNumber: string, code: string, lang: string): Promise<AuthResponse> => {
    return (await axios.post('/proxy/account-recovery-api.bpmn/api/v1/account-recovery/verifyCode/registration/sms', {
        phoneNumber,
        code,
        lang
    })).data;
};

export const checkingCodeEmailAndGettingTokenReg = async (email: string, code: string, lang: string): Promise<AuthResponse> => {
    return (await axios.post('/proxy/account-recovery-api.bpmn/api/v1/account-recovery/verifyCode/registration/email', {
        email,
        code,
        lang
    })).data;
};

export const sendNewPassword = async (target: string, code: string, lang: string, newPassword: string): Promise<AuthResponse> => {
    return (await axios.post('/proxy/account-recovery-api.bpmn/auth/login/recovery/verify/change', {
        target,
        code,
        lang,
        newPassword
    })).data;
};

export const refreshAuthToken = async (refreshToken: string): Promise<AuthResponse> => {
    return (await axios.post('/proxy/account-recovery-api.bpmn/auth/login/refresh/token', {refreshToken})).data;
};

export const getRefreshToken = async () => {
    return (await axios.post('/proxy/account-recovery-api.bpmn/auth/login/refresh/token', {}, {headers: {Authorization: 'Bearer ' + getCookie('GATEWAY')}})).data;
}

export const getCompanyFromContext = async (): Promise<ContextCompany[]> => {
    return (await request.get('/proxy/profile-api.bpmn/api/v1/profile/companies-from-context')).data;
};

export const setMainCompany = async (bin: string) => {
    return (await request.put(`/proxy/profile-api.bpmn/api/v1/profile/make-users-main-company/${bin}`)).data;
};

export const getAvatar = async () => {
    return URL.createObjectURL((await request.get(`/proxy/profile-api.bpmn/api/v1/profile/avatar`, {responseType: 'blob'})).data);
}

export const logOut = async () => {
    return await request.get(`/proxy/account-recovery-api.bpmn/auth/logout`);
}

export const saveUserLocale = async (locale: string): Promise<any> => {
    return await request.post(`/proxy/profile-api.bpmn/api/v1/user-entity/set-locale/${locale}`, {})
}
